import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ 'select', 'template', 'list', 'iconApprovedTemplate' ]

  addExisting(event) {
    event.preventDefault()

    if(!this.selectTarget.selectedIndex) {
      return
    }

    const option = this.selectTarget.options[this.selectTarget.selectedIndex]

    const fullName = option.textContent
    const dutyId = option.value
    const shortName = option.getAttribute('data-short-name')
    const locationFullName = option.getAttribute('data-location-full-name')
    const startsAt = option.getAttribute('data-starts-at')
    const endsAt = option.getAttribute('data-ends-at')
    const hoursHumanized = option.getAttribute('data-hours-humanized')
    const ar = option.getAttribute('data-ar')
    const oncall = option.getAttribute('data-oncall')
    const pos = option.getAttribute('data-pos')
    const cssSelector = option.getAttribute('data-css-selector')

    let content = this.templateTarget.innerHTML

    content = content.replace(/CHILD_INDEX/g, new Date().valueOf())
    content = content.replace(/LOCATION_FULL_NAME/g, locationFullName)
    content = content.replace(/DUTY_ID/g, dutyId)
    content = content.replace(/FULL_NAME/g, fullName)
    content = content.replace(/SHORT_NAME/g, shortName)
    content = content.replace(/STARTS_AT/g, startsAt)
    content = content.replace(/ENDS_AT/g, endsAt)
    content = content.replace(/HOURS_HUMANIZED/g, hoursHumanized)
    content = content.replace(/CSS_SELECTOR/g, cssSelector)
    content = content.replace(/TEMPLATE_ONCALL/g, oncall)
    content = content.replace(/TEMPLATE_POS/g, pos)
    content = content.replace(/TEMPLATE_AR/g, ar)

    this.listTarget.insertAdjacentHTML('beforeend', content)
  }

  remove(event) {
    const confirmMessage = event.currentTarget.getAttribute('data-turbo-confirm')

    if (confirmMessage && !confirm(confirmMessage)) {
      // If there's a confirm message and user clicks Cancel
      event.preventDefault()
      return false
    }

    event.preventDefault()

    const tr = event.target.closest('tr')
    const index = tr.getAttribute('data-index')

    // search in top level because destroy hidden input is outside table
    let destroyInput = this.element.querySelector(`input[name $= '[${index}][_destroy]' ]`)

    if(destroyInput) {
      destroyInput.value = '1'
    }

    this.listTarget.removeChild(tr)
  }

  iconApprovedHTML() {
    return this.iconApprovedTemplateTarget.innerHTML
  }

  rowTargetConnected(element) {
    const dutyId = element.getAttribute('data-duty-id')
    const dutyIdHiddenEl = element.querySelector('.rota-duty-duty-id-hidden')
    dutyIdHiddenEl.value = dutyId

    const fullName = element.getAttribute('data-duty-full-name')
    const fullNameEl = element.querySelector('.rota-duty-full-name')
    fullNameEl.textContent = fullName

    const shortName = element.getAttribute('data-duty-short-name')
    const shortNameEl = element.querySelector('.rota-duty-short-name')
    shortNameEl.textContent = shortName

    const locationFullName = element.getAttribute('data-duty-location-full-name')
    if(locationFullName != 'null') {
      const locationFullNameEl = element.querySelector('.rota-duty-location-full-name')
      locationFullNameEl.textContent = locationFullName
    }

    const oncall = element.getAttribute('data-duty-oncall') == 'true'
    if(oncall) {
      let oncallEl = element.querySelector('.rota-duty-oncall')
      oncallEl.innerHTML = this.iconApprovedHTML()
    }


    const pos = element.getAttribute('data-duty-pos') == 'true'
    if(pos) {
      let posEl = element.querySelector('.rota-duty-pos')
      posEl.innerHTML = this.iconApprovedHTML()
    }

    const cssSelector = element.getAttribute('data-duty-css-selector')
    if(cssSelector) {
      const cssSelectorEl = element.querySelector('.rota-duty-css-selector .duty-colors')
      cssSelectorEl.classList.add(cssSelector)
    }

    const ar = element.getAttribute('data-duty-ar') == 'true'

    if(ar) {
      let arEl = element.querySelector('.rota-duty-ar')
      arEl.innerHTML = this.iconApprovedHTML()
    } else {
      const startsAt = element.getAttribute('data-duty-starts-at')
      const startsAtEl = element.querySelector('.rota-duty-starts-at')
      startsAtEl.textContent = startsAt

      const endsAt = element.getAttribute('data-duty-ends-at')
      const endsAtEl = element.querySelector('.rota-duty-ends-at')
      endsAtEl.textContent = endsAt

      const hoursHumanized = element.getAttribute('data-duty-hours-humanized')
      if(hoursHumanized) {
        const hoursEl = element.querySelector('.rota-duty-hours')
        hoursEl.textContent = hoursHumanized
      }
    }

    this.selectTarget.tomselect.clear() // reset existing duties select
  }
}
